import { Grid } from '@mlc/web-ui-toolkit';
import React from 'react';
import { SearchDataItem } from '../../../../logic/domains/search.domain';
import { SearchElements } from '../SearchElements';
import SearchFilters from '../../SearchFilters/SearchFilters';
import ViewGroupsButton from '../ViewGroupsButton/ViewGroupsButton';
import * as Styled from './styled';

export interface Client {
	displayName: string;
	planId: string | null;
	partyFid: string | null;
}

interface Props {
	onSearchSubmit: (searchQuery: string) => void;
	onSelectedFn: (
		clientNumber: string,
		clientToken: string,
		type: string
	) => void;
	data: Array<SearchDataItem> | null;
	recentClients: Array<SearchDataItem> | null;
}

interface State {
	value: string;
}

const initialState: State = {
	value: '',
};

const AdvancedSearchBar = (props: Props) => {
	const [state, setState] = React.useState(initialState);
	const elements = SearchElements;

	function handleSearchSubmit() {
		props.onSearchSubmit(state.value);
	}

	function onChanged(searchQuery: string) {
		setState(prevState => ({
			...prevState,
			value: searchQuery,
		}));
	}

	function onSelected(
		profileNumber: string,
		profileToken: string,
		type: string
	) {
		props.onSelectedFn(profileNumber, profileToken, type);
	}
	const analyticsId = 'search-results-page-quick-search';
	return (
		<Styled.AdvancedSearchWrapper
			data-id={SearchElements.clientSearchContainer}
			data-analytics-group={analyticsId}
		>
			<Grid>
				<Styled.SearchBar>
					<Styled.AdvancedSearchInputColumn md="6" sm="12">
						<Styled.QuickSearch
							data={props.data}
							onChangedFn={onChanged}
							onSelectedFn={onSelected}
							onSearchFn={handleSearchSubmit}
							recentClients={props.recentClients}
							analyticsId={analyticsId}
						/>
					</Styled.AdvancedSearchInputColumn>
					<Styled.AdvancedSearchFiltersColumn md="3" sm="12">
						<SearchFilters theme="dark" />
					</Styled.AdvancedSearchFiltersColumn>
					<Styled.ViewGroupsColumn md="3" sm="12">
						<ViewGroupsButton theme="dark" />
					</Styled.ViewGroupsColumn>
				</Styled.SearchBar>
			</Grid>
		</Styled.AdvancedSearchWrapper>
	);
};

export default AdvancedSearchBar;
